import { Component, Input, OnInit } from '@angular/core';
import { DeviceService, ReqService } from '@core/services';
import { IHotelStaticInfo } from '@core/models/HotelStaticInfo/hotelStaticInfo.interface';
import { BestRoomPriceboxComponent } from '../best-room-pricebox/best-room-pricebox.component';
import { ProviderInfoComponent } from '@commons/provider-info/provider-info.component';
import { BestRoomPriceboxMobileComponent } from '../best-room-pricebox-mobile/best-room-pricebox-mobile.component';
import { LoaderDetailComponent } from '@commons/loader-detail/loader-detail.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'price-box',
    templateUrl: './price-box.component.html',
    styleUrls: ['./price-box.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        LoaderDetailComponent,
        BestRoomPriceboxMobileComponent,
        ProviderInfoComponent,
        BestRoomPriceboxComponent,
    ],
})
export class PriceBoxComponent implements OnInit {
  @Input()
  bestprice: any;
  @Input()
  busy: boolean;
  @Input()
  bestAvailable: any;
  @Input()
  isLanding: boolean;
  @Input()
  priceByValue: string;
  @Input()
  showAmountTotal: boolean;
  @Input()
  isDisney: boolean;

  public hotelStatic: IHotelStaticInfo;
  public isExperts: boolean;
  public isMobile: boolean;

  constructor(
    private readonly deviceService: DeviceService,
    private readonly reqService: ReqService,
  ) {
    this.isExperts = this.reqService.isExperts();
    this.hotelStatic = this.reqService.getHotelStaticInfo();
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
  }
}
